import React, { Component } from 'react'
import Menu from './includes/Menu'
import { Grid } from '../../../node_modules/@material-ui/core';
import BusinessAssetMgmtChart from '../assets/images/business-asset-mgmt-chart.png';
import BusinessAssetMgmtChartSC from '../assets/images/business-asset-mgmt-chart-sc.png';
import BusinessAssetMgmtChartEN from '../assets/images/business-asset-mgmt-chart-en.png';

const lang = '';

class BusinessAssetManagement extends Component {
  constructor(props) {
    super(props);
    this.lang = (props.lang) ? props.lang : '';
  }

  componentDidMount() {
    document.title = this.getLangText({
      'tc': '運營咨詢',
      'sc': '运营咨询',
      'en': 'Operations Consulting'
    });
  }

  getLangText(langJson) {
    return (this.lang) ? langJson[this.lang] : langJson['tc'];
  }

  render(){
    return(
      BusinessAssetManagementJSX(this)
    );
  }
}

const BusinessAssetManagementJSX = (ctx) => (
  <div className={ (ctx.lang === 'en' ? 'en' : '') }>
    <Menu lang={ ctx.lang } />
  
    <div className='main-content-container'>
      <div className='main-content-inner-wrapper business'>
        <Grid container spacing={0}>
          <Grid item id='page-title'>
            <span>
              {
                ctx.getLangText({
                    'tc': '運營外包咨詢',
                    'sc': '运营外包咨询',
                    'en': 'Operations Outsourcing Consulting'
                })
              }
            </span>
          </Grid>
        </Grid>
        <div style={{clear:'both'}}></div>

        <div className='business-container'>
          <Grid container spacing={0} className='content-container'>
            {/* <Grid item style={{paddingBottom:'30px'}}>
              <p>
                {
                  ctx.getLangText({
                      'tc': `美國匯寶有限公司是由美國全國期貨協會 (NFA) 監管 (註冊號碼：0507203)的投資管理公司。公司設立並管理了匯寶基金(Pool ID: P129005)，
                            通過其基金管理人自身成熟的投資研究能力及外部資源，為投資者進行環球資產配置，提供優良、穩定的投資回報。`,
                      'sc': `美国汇宝有限公司是由美国全国期货协会 (NFA) 监管 (注册号码：0507203)的投资管理公司。公司设立并管理了汇宝基金(Pool ID: P129005)，
                            通过其基金管理人自身成熟的投资研究能力及外部资源，为投资者进行环球资产配置，提供优良、稳定的投资回报。`,
                      'en': `Huibao Global Markets USA Limted Company is authorized and regulated by National Futures Association(NFA)(Registration number：0507203). 
                            By settting up and managing Huibao Fund(Pool ID: P129005), we have built up mature investment research capabilities 
                            and sufficient external resources, allocating investors' global assets with excellent and stable returns.`
                  })
                }
              </p>
            </Grid> */}

            {/* <Grid item style={{paddingBottom:'30px'}}>
              <span className='business-adv-text'>
                {
                  ctx.getLangText({
                      'tc': '量化策略為核心',
                      'sc': '量化策略为核心',
                      'en': 'Quantitative Strategy Oriented'
                  })
                }
              </span>
            </Grid> */}

            <Grid item style={{paddingBottom:'30px'}}>
              <p>
                {
                  ctx.getLangText({
                      'tc': `
                      互聯網運營外包解決方案涵蓋了企業運營中的各個主要流程，從最前端的客戶聯絡中心，到企業內部的後台支持業務，以數據中心作為技術平台和網絡資源的有力支撐，能夠為客戶提供多類別、個性化、一站式的運營外包解決方案。`,
                      'sc': `互联网运营外包解决方案涵盖了企业运营中的各个主要流程，从最前端的客户联络中心，到企业内部的后台支持业务，以数据中心作为技术平台和网络资源的有力支撑，能够为客户提供多类别、个性化、一站式的运营外包解决方案。`,
                      'en': `The internet operations outsourcing solution covers all the main processes of company operations. 
                          From the front-end customer service centre to the internal back-office support, we use the data centre as the main support for the technology platforms and network resources. 
                          It helps provide clients with various personalized, one-stop operations outsourcing solutions.`
                  })
                }
              </p>
            </Grid>

            <div className='business-chart'>
              <span className='business-adv-text'>
                {
                  ctx.getLangText({
                      'tc': '優勢',
                      'sc': '优势',
                      'en': 'Advantages'
                  })
                }
              </span>

              <Grid container spacing={0} justify='center' style={{padding:'20px'}}>
                <Grid item>
                  <img id='img-business-chart' style={{ display:'inline-block', verticalAlign:'middle', width:'100%'}}
                       src={ctx.getLangText({
                                              'tc': BusinessAssetMgmtChart,
                                              'sc': BusinessAssetMgmtChartSC,
                                              'en': BusinessAssetMgmtChartEN
                                              })
                                            } />
                </Grid>
              </Grid>
            </div>

          </Grid>
        </div>
      </div>
    </div>
  </div>
)

export default BusinessAssetManagement



// WEBPACK FOOTER //
// ./src/components/pages/AssetManagement.js